const getToken = () => {
    try {
        const token = localStorage?.getItem('token') || null;
        return token && token.trim() !== "" ? token : null;
    } catch (err) {
        return null;
    }
};
export default getToken